import { FC } from "react";

import { CrudEditContextWrapper } from "@ryde/controls";
import {
  IBookingFormDrawerProps,
  IExtendableDto,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { DrawerFormProviderWrapper } from "../edit-form";
import { BookingEditInner } from "./booking-edit-inner";
import { BookingEditWrapper } from "./booking-edit.wrapper";

export const BookingEditFormDrawer: FC<
  IBookingFormDrawerProps & IInjectedDrawerProps
> = ({ resolveFn, onCloseDrawer, mode, id, idCopyFrom, drawerNumber }) => {
  return (
    <CrudEditContextWrapper<IExtendableDto>
      entity="booking"
      mode={mode}
      id={id}
      idCopyFrom={idCopyFrom}
    >
      <DrawerFormProviderWrapper>
        <BookingEditWrapper>
          <BookingEditInner
            resolveFn={resolveFn}
            onCloseDrawer={onCloseDrawer}
            drawerNumber={drawerNumber}
          />
        </BookingEditWrapper>
      </DrawerFormProviderWrapper>
    </CrudEditContextWrapper>
  );
};
